// extracted by mini-css-extract-plugin
export var animateCircle = "hidden-scroll-item-module--animate-circle--gblRL";
export var bounce = "hidden-scroll-item-module--bounce--5ttiO";
export var ldsRing = "hidden-scroll-item-module--lds-ring--tVyvM";
export var scrollItem = "hidden-scroll-item-module--scrollItem--IUON5";